export const unifyListParams = (response) => {
    const { data } = response;
    if (data && data.body) {
        return {
            moreStatements: !(data.body.last || data.body.numberOfElements < data.body.size),
            pageNumber: data.body.pageable.pageNumber + 1,
            totalCount: data.body.totalElements,
            statements: data.body.content,
        };
    }
    return data.data;
};

export const maskedAccountNumber = (accountNumber) => {
    const amountOfVisibleNumbers = 4;
    const minAmountOfMaskedNumbers = 4;
    const visibleNumbers = accountNumber?.substring(accountNumber?.length - amountOfVisibleNumbers);
    const amountOfMaskedNumbers = accountNumber?.length - amountOfVisibleNumbers;
    const amountOfAsteriskMask =
        amountOfMaskedNumbers >= minAmountOfMaskedNumbers ? amountOfMaskedNumbers : minAmountOfMaskedNumbers;
    const mask = Array(amountOfAsteriskMask + 1).join("*");
    return mask + visibleNumbers;
};

export default unifyListParams;
